<template>
  <div class="box">
    <div class="box-title">暂存箱位/架位：{{ keyword }}</div>
    <div v-if="storageBoxBookList.length > 0">
      <van-row
        :gutter="10"
        v-for="(item, index) in storageBoxBookList"
        :key="index"
        class="little-box"
      >
        <van-col v-if="item.title" class="form" span="24">
          <span class="title">题名：</span
          ><span class="desc">{{ item.title }}</span>
        </van-col>
        <van-col v-if="item.author" class="form" span="24">
          <span class="title">作者：</span
          ><span class="desc">{{ item.author }}</span>
        </van-col>
        <van-col v-if="item.isbnNumber" class="form" span="24">
          <span class="title">ISBN号：</span
          ><span class="desc">{{ item.isbnNumber }}</span>
        </van-col>
        <van-col v-if="item.press" class="form" span="24">
          <span class="title">出版社：</span
          ><span class="desc">{{ item.press }}</span>
        </van-col>
        <van-col v-if="item.publishDate" class="form" span="24">
          <span class="title">出版年：</span
          ><span class="desc">{{ item.publishDate }}</span>
        </van-col>
        <van-col v-if="item.language" class="form" span="24">
          <span class="title">语种：</span
          ><span class="desc">{{ item.language }}</span>
        </van-col>
        <van-col v-if="item.copiesNumber" class="form" span="24">
          <span class="title">已有复本数量：</span
          ><span class="desc">{{ item.copiesNumber }}</span>
        </van-col>
        <van-col v-if="item.copiesLocation" class="form" span="24">
          <span class="title">已有复本分馆地：</span
          ><span class="desc">{{ item.copiesLocation }}</span>
        </van-col>
        <van-col v-if="item.price" class="form" span="24">
          <span class="title">价格：</span
          ><span class="desc">{{ item.price }}</span>
        </van-col>
        <van-col v-if="item.authorIsFudan" class="form" span="24">
          <span class="title">作者是否为复旦师工：</span
          ><span class="desc">{{
            item.authorIsFudan == "Y" ? "是" : "否"
          }}</span>
        </van-col>
        <van-col v-if="item.comments" class="form" span="24">
          <span class="title">单册备注：</span
          ><span class="desc">{{ item.comments }}</span>
        </van-col>
      </van-row>
    </div>
    <div v-else><van-empty description="暂无图书" /></div>
  </div>
</template>
<script>
import { getStorageBoxBookList } from "@/api/storage-box";
import { STATUS_CODE_OK } from "@/config";
export default {
  name: "StorageBox",
  data() {
    return {
      keyword: "",
      storageBoxBookList: [],
    };
  },
  created() {
    this.keyword = this.$route.query.keyword;
    this.handleBookListGet();
  },

  methods: {
    async handleBookListGet() {
      const { data } = await getStorageBoxBookList({
        storageBox: this.keyword,
      });
      if (data.code === STATUS_CODE_OK) {
        this.storageBoxBookList = data.data.pageInfo;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
  overflow-y: auto;
  background-color: #f8f8f8;
  .box-title {
    font-size: 16px;
    font-weight: bolder;
    background-color: #fff;
    padding: 10px;
    box-shadow: 0 0 5px #ccc;
  }
  .little-box {
    box-shadow: 0 0 5px #ccc;
    border-radius: 5px;
    padding: 5px 10px;
    margin: 10px;
    background-color: #fff;
    font-size:14px;
    &:last-child {
      margin-bottom: 0;
    }
    .form {
      padding: 5px 0;
      .title {
        color: #000;
      }
      .desc {
        color: #777;
      }
    }
  }
}
</style>
